import React from 'react';
import { ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data/mock';
import NorthlightLogo from './NorthlightLogo';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navItems = [
    { name: 'Home', href: '#' },
    { name: 'Leistungen', href: '#services' },
    { name: 'Portfolio', href: '#portfolio' },
    { name: 'Zusammenarbeit', href: '#pricing' },
    { name: 'Erstgespräch', href: '#booking' },
  ];

  const handleNavClick = (e, href) => {
    e.preventDefault();
    if (href === '#') {
      scrollToTop();
    } else {
      document.getElementById(href.substring(1))?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="relative pt-20 pb-8 border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 relative z-10">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-12 mb-14">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="mb-5">
              <NorthlightLogo size="default" />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-md">
              {companyInfo.description}
            </p>
          </div>

          {/* Navigation + Contact */}
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="font-semibold text-sm mb-4 text-white tracking-wide">Navigation</h4>
              <ul className="space-y-2.5">
                {navItems.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      onClick={(e) => handleNavClick(e, item.href)}
                      className="text-gray-500 hover:text-[#ff84e4] transition-colors text-sm"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4 text-white tracking-wide">Kontakt</h4>
              <ul className="space-y-2.5 text-sm text-gray-500">
                <li>
                  <a href={`mailto:${companyInfo.email}`} className="hover:text-[#ff84e4] transition-colors">
                    {companyInfo.email}
                  </a>
                </li>
                <li>
                  <a href={`tel:${companyInfo.phone}`} className="hover:text-[#ff84e4] transition-colors">
                    {companyInfo.phone}
                  </a>
                </li>
                <li>Remote – deutschlandweit</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/[0.06] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-600">
            &copy; {new Date().getFullYear()} {companyInfo.name}. Alle Rechte vorbehalten.
          </p>

          <div className="flex items-center gap-6 text-xs text-gray-600">
            <Link to="/impressum" className="hover:text-gray-400 transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-gray-400 transition-colors">Datenschutz</Link>
            <Link to="/agb" className="hover:text-gray-400 transition-colors">AGB</Link>
          </div>

          {/* Scroll to Top */}
          <button
            data-testid="scroll-to-top"
            onClick={scrollToTop}
            className="w-9 h-9 rounded-full bg-white/[0.04] border border-white/[0.08] flex items-center justify-center text-gray-500 hover:text-white hover:bg-white/[0.08] transition-all duration-300"
          >
            <ArrowUp size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
